/** Max characters for a wish (main entry field + review counter). */
export const WISH_MAX = 60;
